export const documentFormat = (document: string): string => {
  if (document !== null) {
    return document.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
  }
  return '--';
};
